// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing Supabase environment variables: VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set in your .env file'
  );
}

// Log environment variables on startup (for debugging, dev only)
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  console.log('[Supabase Client] Initializing with:');
  console.log('[Supabase Client] URL:', SUPABASE_URL ? '✓ Set' : '✗ Missing');
  console.log('[Supabase Client] Key:', SUPABASE_PUBLISHABLE_KEY ? '✓ Set' : '✗ Missing');

  if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
    console.error('CRITICAL: Supabase environment variables are not set!');
    console.error('Missing:', {
      VITE_SUPABASE_URL: !SUPABASE_URL,
      VITE_SUPABASE_PUBLISHABLE_KEY: !SUPABASE_PUBLISHABLE_KEY
    });
    console.error('Available env vars:', Object.keys(import.meta.env).filter(k => k.startsWith('VITE_')));
  }
}

// Create a storage adapter that falls back gracefully if localStorage is unavailable
const createStorageAdapter = () => {
  // Try to use localStorage first
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('__storage_test__', '1');
      localStorage.removeItem('__storage_test__');
      return localStorage;
    }
  } catch (e) {
    // localStorage may be unavailable in some contexts
    console.debug('localStorage unavailable, using in-memory storage', e);
  }

  // Fallback to in-memory storage
  const store: Record<string, string> = {};
  return {
    getItem: (key: string) => store[key] ?? null,
    setItem: (key: string, value: string) => {
      store[key] = value;
    },
    removeItem: (key: string) => {
      delete store[key];
    },
  };
};

const storage = createStorageAdapter();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: storage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
